import { render } from "./TeachingPlanList.vue?vue&type=template&id=51908982&scoped=true&ts=true"
import script from "./TeachingPlanList.vue?vue&type=script&lang=ts"
export * from "./TeachingPlanList.vue?vue&type=script&lang=ts"

import "./TeachingPlanList.vue?vue&type=style&index=0&id=51908982&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51908982"]])

export default __exports__